export default {
	'userCancel': '사용자 취소',
	'addrLp': 'LP 계약 주소',
	'bscInLbb': 'BSC는 LBBCoin으로 넘어갑니다.',
	'goSwap': 'CSwap 거래',
	'sumLbb': '누적 {0} OC',
	'lookLbb': '계약 보기',
	'addrLbb': 'OC 계약 주소',
	'addrDead': '블랙홀 주소',
	'addrMarket': '마케팅 주소',
	'ratioTotal': '판매 총 슬라이딩 포인트: 10%',
	'ratioLp': 'a. 유동성 계수: 5%',
	'ratioDead': 'b. 제거 계수: 3%',
	'ratioInv': 'c. 초대 계수: 1%',
	'ratioMarket': 'd. 마케팅 계수: 1%',
	'contractDesc': '논리적 전체 체인 구현',
	'contract': '계약',
	'inviteTotal': '전체 네트워크 초대 보상: {0} OC',
	'inviteMy': '내 초대 보상: {0} OC',
	'lpTotal': '전체 네트워크 유동성 보상: {0} OC',
	'lpMy': '내 유동성 보상: {0} OC',
	'lpDesc': '내 / 전체 네트워크 유동성: {0} / {1} LCC',
	'lpAdd': '유동성 추가',
	'lp': '유동성',
	'invSell': '최대 1% 초대 보상',
	'lpSell': '유동성 가중치를 보유하면 매 매출의 5% 를 보상합니다',
	'myInvites': '나의 초대',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': '나의 추천인',
	'invite': '초대',
	'inviteNotice1': '상대방에게 0.1 OC 보내기',
	'inviteNotice2': '상대방이 확인한 후에 초대에 성공하다',
	'inviteBind': '추천인을 묶으세요',
	'chainConfirm': '위쪽 체인 중...',
	'{0} Operate Fast': '{0} 작업이 너무 잦습니다. {1} 초 후에 계속하십시오.',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': '확인',
	'Osnft Detail': '자세히 보기',
	'{0} Not Enogugh': '{0} 이(가) 부족합니다.',
	'Operate Success': '작업 성공',
	'zlang143': '복제 성공',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'ocLockTitle': 'OC 잠금',
	'ocLockDeposit': '예치',
	'ocLockActive': 'Status',
	'ocLockReleased': '해제됨',
	'ocLockClaim': '출금',
	'themeNeon': '네온 블루',
	'themeIce': '아이스 회로',
	'themeViolet': '바이올렛 골드',
	'themeAurora': '오로라 민트',
	'themeEmber': '엠버 나이트',
	'themeMono': '딥 모노',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
}
